import * as React from "react";
import { singleton } from "logic/singleton";
const SelectEntitiesContext = React.createContext(void 0);
export default singleton("contexts.SelectEntitiesContext", () => SelectEntitiesContext);
